<div>
  <form [formGroup]="baseFormGroup" #f="ngForm" class="">
    <div class="form-group row">
      <div class="col-md-12">
        <yt-dropdown-picklist
          id="ddlValuta" 
          [ModelName]="'valuta'" 
          [GetName]="'getConvertible'" 
          [ModelProperty]="'Sifra,ISOAlpha3Code,Naziv'"
          formControlName="ValutaID"          
          [Label]="'DOKUMENTSTAVKE.VALUTANAZIV.SINGULAR'"
          #autofocus
          (OnItemSelected)='onValutaSelect()'>
        </yt-dropdown-picklist>
        <!-- <yt-dropdown-picklist
          [ModelName]="'valuta'" 
          [GetName]="'getConvertible'" 
          [ModelProperty]="'Naziv'"
          [OrderBy]="'Naziv'"
          [AllowAddNew]="false"
          formControlName="ValutaID"
          [Label]="'DOKUMENTSTAVKE.VALUTANAZIV.SINGULAR'"
          [Type]="ID"
          ></yt-fw-dropdown-picklist>-->
        <div class="form-error" *ngIf="submitted && fc.ValutaID.invalid">
          <span *ngFor="let validation of errorMessages.ValutaID">
            <span class="error-message" *ngIf="fc.ValutaID.hasError(validation.type)">
              <span [ngClass]="{'slideInRight': fc.ValutaID.hasError(validation.type), 'animated': true}" translate="{{validation.message}}"></span>
            </span>
          </span>
        </div>
      </div>
    </div>
   
    <div *ngIf="Parameters != null && Parameters.count() > 0 && Parameters.get(0).get(0).Value=='U'">
    <!-- Početno stanje -->
    <div class="form-group row mt-0 mb-0" >
      <label class="col-form-label col-md-9 pr-0">
          3)
          <span translate="DOKUMENTSTAVKE.POCETNOSTANJE.SINGULAR"></span>
      </label>
       <div class="col-md-3">
         <!-- <input
           class='form-control text-right'
           type="number"
           formControlName="PocetnoStanje"
           name="txtPocetnoStanje"> -->
           <yt-number-input-v2
              formControlName="PocetnoStanje"
              name="txtPocetnoStanje"
              [Label]="'DOKUMENTSTAVKE.POCETNOSTANJE.SINGULAR'">
           </yt-number-input-v2>
         <div class="form-error" *ngIf="submitted && fc.PocetnoStanje.invalid">
           <span *ngFor="let validation of errorMessages.PocetnoStanje">
             <span class="error-message" *ngIf="fc.PocetnoStanje.hasError(validation.type)">
               <span [ngClass]="{'slideInRight': fc.PocetnoStanje.hasError(validation.type), 'animated': true}" translate="{{validation.message}}"></span>
             </span>
           </span>
         </div>
       </div>
    </div>
    <!-- Kraj početno stanje -->
     <!-- Interni ulaz -->
     <div class="form-group row mt-0 mb-0">
      <label class="col-form-label col-md-9 pr-0">
          6)
          <span translate="DOKUMENTSTAVKE.INTERNIULAZ.SINGULAR"></span>
      </label>
      <div class="col-md-3">
        <!-- <input
          class='form-control text-right'
          type="number"
          formControlName="InterniUlaz"
          name="txtInterniUlaz"> -->
        <yt-number-input-v2
          formControlName="InterniUlaz"
          name="txtInterniUlaz">
        </yt-number-input-v2>
        <div class="form-error" *ngIf="submitted && fc.InterniUlaz.invalid">
          <span *ngFor="let validation of errorMessages.InterniUlaz">
            <span class="error-message" *ngIf="fc.InterniUlaz.hasError(validation.type)">
              <span [ngClass]="{'slideInRight': fc.InterniUlaz.hasError(validation.type), 'animated': true}" translate="{{validation.message}}"></span>
            </span>
          </span>
        </div>
      </div>
    </div>
    <!-- Kraj Ulaz sa Interni ulaz -->

    <!-- Interni ulaz Evra na ime pružanja platnih usluga -->
    <div class="form-group row mt-0 mb-0">
      <label class="col-form-label col-md-9 pr-0">
          6a)
          <span translate="DOKUMENTSTAVKE.INTERNIULAZPLATUSL.SINGULAR"></span>
      </label>
      <div class="col-md-3">
        <!-- <input
          class='form-control text-right'
          type="number"
          formControlName="InterniUlaz"
          name="txtInterniUlaz"> -->
        <yt-number-input-v2
          formControlName="InterniUlazPlatUsl"
          name="txtInterniUlazPlatUsl">
        </yt-number-input-v2>
        <div class="form-error" *ngIf="submitted && fc.InterniUlazPlatUsl.invalid">
          <span *ngFor="let validation of errorMessages.InterniUlazPlatUsl">
            <span class="error-message" *ngIf="fc.InterniUlazPlatUsl.hasError(validation.type)">
              <span [ngClass]="{'slideInRight': fc.InterniUlazPlatUsl.hasError(validation.type), 'animated': true}" translate="{{validation.message}}"></span>
            </span>
          </span>
        </div>
      </div>
    </div>
    <!-- Kraj Ulaz sa Interni ulaz Evra na ime pružanja platnih usluga-->

    <hr>

    <!-- Kupovina od banke -->
    <div class="form-group row mt-0 mb-0">
      <label class="col-form-label col-md-9 pr-0">
          4)
          <span translate="DOKUMENTSTAVKE.KUPOVINAODBANKE.SINGULAR"></span>
      </label>
      <div class="col-md-3">
        <!-- <input
          class='form-control text-right'
          type="number"
          formControlName="KupovinaOdBanke"
          name="txtKupovinaOdBanke"> -->
        <yt-number-input-v2
          formControlName="KupovinaOdBanke"
          name="txtKupovinaOdBanke">
        </yt-number-input-v2>
        <div class="form-error" *ngIf="submitted && fc.KupovinaOdBanke.invalid">
          <span *ngFor="let validation of errorMessages.KupovinaOdBanke">
            <span class="error-message" *ngIf="fc.KupovinaOdBanke.hasError(validation.type)">
              <span [ngClass]="{'slideInRight': fc.KupovinaOdBanke.hasError(validation.type), 'animated': true}" translate="{{validation.message}}"></span>
            </span>
          </span>
        </div>
      </div>
    </div>
    <!-- Kraj kupovina od banke -->

    <!-- Ulaz sa deviznog računa -->
    <div class="form-group row mt-0 mb-0">
        <label class="col-form-label col-md-9 pr-0">
            5)
            <span translate="DOKUMENTSTAVKE.ULAZSADEVIZNOGRACUNA.SINGULAR"></span>
        </label>
        <div class="col-md-3">
          <!-- <input
            class='form-control text-right'
            type="number"
            formControlName="UlazSaDeviznogRacuna"
            name="txtUlazSaDeviznogRacuna"> -->
          <yt-number-input-v2
            formControlName="UlazSaDeviznogRacuna"
            name="txtUlazSaDeviznogRacuna">
          </yt-number-input-v2>
          <div class="form-error" *ngIf="submitted && fc.UlazSaDeviznogRacuna.invalid">
            <span *ngFor="let validation of errorMessages.UlazSaDeviznogRacuna">
              <span class="error-message" *ngIf="fc.UlazSaDeviznogRacuna.hasError(validation.type)">
                <span [ngClass]="{'slideInRight': fc.UlazSaDeviznogRacuna.hasError(validation.type), 'animated': true}" translate="{{validation.message}}"></span>
              </span>
            </span>
          </div>
        </div>
      </div>
      <!-- Kraj Ulaz sa deviznog računa -->

   
    </div>

    <div class="form-group row mt-0 mb-0">
      <label class="col-form-label col-md-9 pr-0">
        <span *ngIf="Parameters != null && Parameters.count() > 0 && Parameters.get(0).get(0).Value == 'U'">7) </span>
        <span *ngIf="Parameters != null && Parameters.count() > 0 && Parameters.get(0).get(0).Value == 'I'">8) </span>
        <span translate="DOKUMENTSTAVKE.IZNOSVALUTE.SINGULAR"></span>
      </label>
      <div class="col-md-3">
        <!-- <yt-input
          [Type]="'number'"
          [Label]="'DOKUMENTSTAVKE.IZNOSVALUTE.SINGULAR'"
          formControlName="IznosValute">
        </yt-input> -->
        <!-- <input
          class='form-control text-right'
          type="number"
          formControlName="IznosValute"
          name="txtIznosValute"> -->
        <yt-number-input-v2
          formControlName="IznosValute"
          name="txtIznosValue">
        </yt-number-input-v2>
        <div class="form-error" *ngIf="submitted && fc.IznosValute.invalid">
          <span *ngFor="let validation of errorMessages.IznosValute">
            <span class="error-message" *ngIf="fc.IznosValute.hasError(validation.type)">
              <span [ngClass]="{'slideInRight': fc.IznosValute.hasError(validation.type), 'animated': true}" translate="{{validation.message}}"></span>
            </span>
          </span>
        </div>
      </div>
    </div>
    <div class="form-group row mt-0 mb-0">
      <label class="col-form-label col-md-9 pr-0 text-right">
        <span translate="DOKUMENTSTAVKE.IZNOSPOKURSUTRANS.SINGULAR"></span>
      </label>
      <div class="col-md-3">
        <!-- <yt-input
          [Type]="'number'"
          [Label]="'DOKUMENTSTAVKE.IZNOSPOKURSUTRANS.SINGULAR'"
          formControlName="IznosPoKursuTrans">
        </yt-input> -->
        <!-- <input
          class='form-control text-right'
          type="number"
          formControlName="IznosPoKursuTrans"
          name="txtIznosPoKursuTrans"> -->
        <yt-number-input-v2
          formControlName="IznosPoKursuTrans"
          name="txtIznosPoKursuTrans">
        </yt-number-input-v2>
        <div class="form-error" *ngIf="submitted && fc.IznosPoKursuTrans.invalid">
          <span *ngFor="let validation of errorMessages.IznosPoKursuTrans">
            <span class="error-message" *ngIf="fc.IznosPoKursuTrans.hasError(validation.type)">
              <span [ngClass]="{'slideInRight': fc.IznosPoKursuTrans.hasError(validation.type), 'animated': true}" translate="{{validation.message}}"></span>
            </span>
          </span>
        </div>
      </div>
    </div>

  
    <div class="form-group row mt-0 mb-0">
      <label class="col-form-label col-md-9 pr-0 text-right">
        <span translate="DOKUMENTSTAVKE.IZNOSPOSREDNJEMKURSU.SINGULAR"></span>
      </label>
      <div class="col-md-3">
        <!-- <yt-input
          [Type]="'number'"
          [Label]="'DOKUMENTSTAVKE.IZNOSPOSREDNJEMKURSU.SINGULAR'"
          formControlName="IznosPoSrednjemKursu">
        </yt-input> -->
        <!-- <input
          class='form-control text-right'
          type="number"
          formControlName="IznosPoSrednjemKursu"
          name="txtIznosPoSrednjemKursu"> -->
        <yt-number-input-v2
          formControlName="IznosPoSrednjemKursu"
          name="txtIZnosPoSrednjemKursu">
        </yt-number-input-v2>
        <div class="form-error" *ngIf="submitted && fc.IznosPoSrednjemKursu.invalid">
          <span *ngFor="let validation of errorMessages.IznosPoSrednjemKursu">
            <span class="error-message" *ngIf="fc.IznosPoSrednjemKursu.hasError(validation.type)">
              <span [ngClass]="{'slideInRight': fc.IznosPoSrednjemKursu.hasError(validation.type), 'animated': true}" translate="{{validation.message}}"></span>
            </span>
          </span>
        </div>
      </div>
    </div>

    <div *ngIf="Parameters != null && Parameters.count() > 0 && Parameters.get(0).get(0).Value=='I'">
    <hr>
    <!-- Zamena -->
    <div class="form-group row  mt-0 mb-0">
        <label class="col-form-label col-md-9 pr-0">
            9)
            <span translate="DOKUMENTSTAVKE.ZAMENA.SINGULAR"></span>
        </label>
        <div class="col-md-3">
          <!-- <input
            class='form-control text-right'
            type="number"
            formControlName="Zamena"
            name="txtZamena"> -->
          <yt-number-input-v2
            formControlName="Zamena"
            name="txtZamena">
          </yt-number-input-v2>
          <div class="form-error" *ngIf="submitted && fc.Zamena.invalid">
            <span *ngFor="let validation of errorMessages.Zamena">
              <span class="error-message" *ngIf="fc.Zamena.hasError(validation.type)">
                <span [ngClass]="{'slideInRight': fc.Zamena.hasError(validation.type), 'animated': true}" translate="{{validation.message}}"></span>
              </span>
            </span>
          </div>
        </div>
      </div>
      <!-- Kraj Zamena -->

    <!-- Interni izlaz -->
    <div class="form-group row mt-0 mb-0">
        <label class="col-form-label col-md-9 pr-0">
            10)
            <span translate="DOKUMENTSTAVKE.INTERNIIZLAZ.SINGULAR"></span>
        </label>
        <div class="col-md-3">
          <!-- <input
            class='form-control text-right'
            type="number"
            formControlName="InterniIzlaz"
            name="txtInterniIzlaz"> -->
          <yt-number-input-v2
            formControlName="InterniIzlaz"
            name="txtInterniIzlaz">
          </yt-number-input-v2>
          <div class="form-error" *ngIf="submitted && fc.InterniIzlaz.invalid">
            <span *ngFor="let validation of errorMessages.InterniIzlaz">
              <span class="error-message" *ngIf="fc.InterniIzlaz.hasError(validation.type)">
                <span [ngClass]="{'slideInRight': fc.InterniIzlaz.hasError(validation.type), 'animated': true}" translate="{{validation.message}}"></span>
              </span>
            </span>
          </div>
        </div>
      </div>
      <!-- Kraj Ulaz sa Interni izlaz -->

    <!-- Interni izlaz evra na ime pružanja platnih usluga -->
    <div class="form-group row mt-0 mb-0">
        <label class="col-form-label col-md-9 pr-0">
            10a)
            <span translate="DOKUMENTSTAVKE.INTERNIIZLAZEVRAPLATUSL.SINGULAR"></span>
        </label>
        <div class="col-md-3">
          <yt-number-input-v2
            formControlName="InterniIzlazEvraPlatUsl"
            name="txtInterniIzlazEvraPlatUsl">
          </yt-number-input-v2>
          <div class="form-error" *ngIf="submitted && fc.InterniIzlazEvraPlatUsl.invalid">
            <span *ngFor="let validation of errorMessages.InterniIzlazEvraPlatUsl">
              <span class="error-message" *ngIf="fc.InterniIzlazEvraPlatUsl.hasError(validation.type)">
                <span [ngClass]="{'slideInRight': fc.InterniIzlazEvraPlatUsl.hasError(validation.type), 'animated': true}" translate="{{validation.message}}"></span>
              </span>
            </span>
          </div>
        </div>
      </div>
      <!-- Kraj Ulaz sa Interni izlaz -->

    <!-- Izlaz na devizni račun -->
    <div class="form-group row mt-0 mb-0">
        <label class="col-form-label col-md-9 pr-0">
            11)
            <span translate="DOKUMENTSTAVKE.IZLAZNADEVIZNIRACUN.SINGULAR"></span>
        </label>
        <div class="col-md-3">
          <!-- <input
            class='form-control text-right'
            type="number"
            formControlName="IzlazNaDevizniRacun"
            name="txtIzlazNaDevizniRacun"> -->
          <yt-number-input-v2
            formControlName="IzlazNaDevizniRacun"
            name="txtIzlazNaDevizniRacun">
          </yt-number-input-v2>
          <div class="form-error" *ngIf="submitted && fc.IzlazNaDevizniRacun.invalid">
            <span *ngFor="let validation of errorMessages.IzlazNaDevizniRacun">
              <span class="error-message" *ngIf="fc.IzlazNaDevizniRacun.hasError(validation.type)">
                <span [ngClass]="{'slideInRight': fc.IzlazNaDevizniRacun.hasError(validation.type), 'animated': true}" translate="{{validation.message}}"></span>
              </span>
            </span>
          </div>
        </div>
      </div>
      <!-- Kraj Izlaz na devizni račun -->

    <!-- Prodaja banci -->
    <div class="form-group row mt-0 mb-0">
        <label class="col-form-label col-md-9 pr-0">
            12)
            <span translate="DOKUMENTSTAVKE.PRODAJABANCI.SINGULAR"></span>
        </label>
        <div class="col-md-3">
          <!-- <input
            class='form-control text-right'
            type="number"
            formControlName="ProdajaBanci"
            name="txtProdajaBanci"> -->
          <yt-number-input-v2
            formControlName="ProdajaBanci"
            name="txtProdajaBanci">
          </yt-number-input-v2>
          <div class="form-error" *ngIf="submitted && fc.ProdajaBanci.invalid">
            <span *ngFor="let validation of errorMessages.ProdajaBanci">
              <span class="error-message" *ngIf="fc.ProdajaBanci.hasError(validation.type)">
                <span [ngClass]="{'slideInRight': fc.ProdajaBanci.hasError(validation.type), 'animated': true}" translate="{{validation.message}}"></span>
              </span>
            </span>
          </div>
        </div>
      </div>
      <!-- Kraj Prodaja banci -->

      <!-- Prodaja banci po kursu-->
      <div class="form-group row mt-0 mb-0">
        <label class="col-form-label col-md-9 pr-0 text-right">
          <span translate="DOKUMENTSTAVKE.PRODBANCIPOKURSU.SINGULAR"></span>
        </label>
        <div class="col-md-3">
          <yt-number-input-v2
            formControlName="ProdBanciPoKursu"
            name="txtProdBanciPoKursu">
          </yt-number-input-v2>
          <div class="form-error" *ngIf="submitted && fc.ProdBanciPoKursu.invalid">
            <span *ngFor="let validation of errorMessages.ProdBanciPoKursu">
              <span class="error-message" *ngIf="fc.ProdBanciPoKursu.hasError(validation.type)">
                <span [ngClass]="{'slideInRight': fc.ProdBanciPoKursu.hasError(validation.type), 'animated': true}" translate="{{validation.message}}"></span>
              </span>
            </span>
          </div>
        </div>
      </div>
      <!-- Kraj Prodaja banci po kursu-->

      <!-- Prodaja banci po srednjem kursu-->
      <div class="form-group row mt-0 mb-0">
        <label class="col-form-label col-md-9 pr-0 text-right">
          <span translate="DOKUMENTSTAVKE.PRODBANCIPOSREDKURSU.SINGULAR"></span>
        </label>
        <div class="col-md-3">
          <yt-number-input-v2
            formControlName="ProdBanciPoSredKursu"
            name="txtProdBanciPoSredKursu">
          </yt-number-input-v2>
          <div class="form-error" *ngIf="submitted && fc.ProdBanciPoSredKursu.invalid">
            <span *ngFor="let validation of errorMessages.ProdBanciPoSredKursu">
              <span class="error-message" *ngIf="fc.ProdBanciPoSredKursu.hasError(validation.type)">
                <span [ngClass]="{'slideInRight': fc.ProdBanciPoSredKursu.hasError(validation.type), 'animated': true}" translate="{{validation.message}}"></span>
              </span>
            </span>
          </div>
        </div>
      </div>
      <!-- Kraj Prodaja banci po srednjem kursu-->

    <!-- Prodaja banci obavezi -->
    <div class="form-group row mt-0 mb-0">
        <label class="col-form-label col-md-9 pr-0">
            13)
            <span translate="DOKUMENTSTAVKE.PRODAJABANCIOBAVEZI.SINGULAR"></span>
        </label>
        <div class="col-md-3">
          <!-- <input
            class='form-control text-right'
            type="number"
            formControlName="ProdajaBanciObavezi"
            name="txtProdajaBanciObavezi"> -->
          <yt-number-input-v2
            formControlName="ProdajaBanciObavezi"
            name="txtProdajaBanciObavezi">
          </yt-number-input-v2>
          <div class="form-error" *ngIf="submitted && fc.ProdajaBanciObavezi.invalid">
            <span *ngFor="let validation of errorMessages.ProdajaBanciObavezi">
              <span class="error-message" *ngIf="fc.ProdajaBanciObavezi.hasError(validation.type)">
                <span [ngClass]="{'slideInRight': fc.ProdajaBanciObavezi.hasError(validation.type), 'animated': true}" translate="{{validation.message}}"></span>
              </span>
            </span>
          </div>
        </div>
      </div>
      <!-- Kraj Prodaja banci obavezi-->
    </div>

      <div *ngIf="Parameters != null && Parameters.count() > 0 && Parameters.get(0).get(0).Value=='U'">
        <div class="form-group row mt-0 mb-0">
        <label class="col-form-label col-md-9 pr-0">
          <span translate="DOKUMENTSTAVKE.UKUPNO.SINGULAR"></span>
        </label>
        <label class="col-form-label col-md-3 text-right pr-4">
          {{ukupnoUlaz | number : '1.2-2' : userService.GetLocaleString() }}
        </label>
        </div>
      </div>
      <div *ngIf="Parameters != null && Parameters.count() > 0 && Parameters.get(0).get(0).Value=='I'">
        <div class="form-group row mt-0 mb-0">
          <label class="col-form-label col-md-3 pr-0">
            <span translate="DOKUMENTSTAVKE.UKUPNO.SINGULAR"></span>
          </label>
          <label class="col-form-label col-md-3 pr-0 text-right">
            <span translate="DOKUMENT.SINGULAR.OTKUPEFEKTIVE"></span>
          </label>
          <label class="col-form-label col-md-3 text-right pr-4">
            {{ukupnoUlaz | number : '1.2-2' : userService.GetLocaleString() }}
          </label>
          <label class="col-form-label col-md-3 text-right pr-4">
            {{ukupnoIzlaz | number : '1.2-2' : userService.GetLocaleString() }}
          </label>
        </div>
      
        <div class="form-group row mt-0 mb-0">
          <label class="col-form-label col-md-6 pr-0">
            <span translate="DOKUMENTSTAVKE.STANJE.SINGULAR"></span>
          </label>
          <label class="col-md-3">
          </label>
          <label class="col-form-label col-md-3 text-right pr-4">
            {{ukupnoRazlika | number : '1.2-2' : userService.GetLocaleString() }}
          </label>
        </div>
      </div>
    <div class="row">
      <div class="col-md-12">
        <div class="btn-group float-right"></div>
      </div>
    </div>
  </form>
</div>